var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12441_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 23.77H0V15.07H0.82C2.51 15.07 3.89 13.69 3.89 12C3.89 10.31 2.51 8.92998 0.82 8.92998H0V0.22998H32V8.92998H31.18C29.49 8.92998 28.11 10.31 28.11 12C28.11 13.69 29.49 15.07 31.18 15.07H32V23.77ZM1.64 22.13H30.35V16.65C28.14 16.26 26.46 14.33 26.46 12.01C26.46 9.68998 28.14 7.75998 30.35 7.36998V1.87998H1.64V7.35998C3.85 7.74998 5.53 9.67998 5.53 12C5.53 14.32 3.85 16.25 1.64 16.64V22.12V22.13Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9501 3.44995H8.08008V6.31995H10.9501V3.44995Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9501 8.18994H8.08008V11.0599H10.9501V8.18994Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9501 12.9399H8.08008V15.8099H10.9501V12.9399Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9501 17.6799H8.08008V20.5499H10.9501V17.6799Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12441_1446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/IconTicket.4feec7af.svg";
export { ForwardRef as ReactComponent };